<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-money-edit-check-alt"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="servicePriceRangeForm" :labelColumnSize="3">
      <FormRow label="Name">
        <FormInputText placeholder="Name" v-model="servicePriceRange.name" field="name" />
      </FormRow>
      <FormRow label="Min Thickness">
        <FormInputText placeholder="Minimum Thickness" v-model="servicePriceRange.minRange" field="minRange" addon="mm" note="Services to stock greater than or equal to this thickness" />
      </FormRow>
      <FormRow label="Max Thickness">
        <FormInputText placeholder="Maximum Thickness" v-model="servicePriceRange.maxRange" field="maxRange" addon="mm" note="Services to stock less than this thickness" />
      </FormRow>
      <FormRow label="Associated Price Groups">
        <FormMultiSelect :value="servicePriceRangePriceGroups" @input="servicePriceRangePriceGroups = $event" :options="priceGroupList" :loading="priceGroupListLoading" placeholder="Select Price Groups" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: "ServicePriceRangeDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isCreateMode: Boolean
  },
  data() {
    return {
      servicePriceRangeId: null,
      servicePriceRange: {},
      servicePriceRangeForm: {},
      submitting: false,

      servicePriceRangePriceGroups: [],
      priceGroupList: [],
      priceGroupListLoading: false
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Service Price Range' : 'Edit Service Price Range'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    }
  },
  methods: {
    show(servicePriceRange) {
      // Reset form
      this.servicePriceRange = { }
      this.servicePriceRangeId = 0
      this.servicePriceRangeForm = {}
      this.servicePriceRangePriceGroups = []
      this.submitting = false

      if(servicePriceRange != null) {
        this.servicePriceRange = _.cloneDeep(servicePriceRange)
        this.servicePriceRangeId = servicePriceRange.id

        if(this.servicePriceRange.stockPriceGroups != null)
          this.servicePriceRangePriceGroups = this.servicePriceRange.stockPriceGroups.map(priceGroup => { return priceGroup.id })
      }

      // Get User Group list
      // FUTURE: Somehow send a promise to the select component. It can handle loading state based on promise
      this.priceGroupListLoading = true
      this.$apiService.pricingService.getStockPriceGroupList()
      .then(list => {
        this.priceGroupList = list.data.map(priceGroupInfo => {
          return {
            value: priceGroupInfo.id,
            name: priceGroupInfo.name
          }
        })
        this.priceGroupListLoading = false
      })

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var servicePriceRangeData = _.cloneDeep(this.$data.servicePriceRange)
      servicePriceRangeData.stockPriceGroups = this.servicePriceRangePriceGroups

      if(this.isCreateMode) {
        this.$apiService.pricingService.createServicePriceRange(servicePriceRangeData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.servicePriceRangeForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.pricingService.updateServicePriceRange(this.servicePriceRangeId, servicePriceRangeData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.servicePriceRangeForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>